export class Patterns {

    public static ONLY_NUMBERS = '[0-9]*';
    public static COMMA_AND_SEMICOLON_NUMBERS = '^[0-9,.]*$';
    public static NUMBERS_POINT = '[0-9.]*';
    public static LETTERS_WITH_ACCENTS = '[A-zÁ-ú ]*';
    public static LETTERS_NUMBERS_WITH_ACCENTS = '[A-zÁ-ú0-9 ]*';
    public static LETTERS_NUMBERS_AND_PUNCTUATION = '[A-zÁ-ú0-9. ()]*';
    public static LETTERS_NUMBERS_AND_PARENTS = '[A-zÁ-ú0-9 ()]*';
    public static OBSERVATION_DEFINED_CHARACTERS = '^[A-Za-z0-9À-ÿ \'.,;:!¡?¿()<>%/|\\\\@"_*#\\-\\n\\r]*$';
    public static EMAIL_STRICT = '^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$';

}